<div class="fx-layout-row fx-layout-align-center-center">
  <div class="fx-flex-80pc">
    <h4 class="white" *ngIf="quiz">{{ quiz.QuizTitle }}</h4>
    <p-table #dt [columns]="cols" [value]="questions" [paginator]="true" selectionMode="single" [rows]="rows"
      [totalRecords]="totalRecords" [loading]="loading" (onRowSelect)="onRowSelect($event)">
      <!-- <ng-template pTemplate="caption">
          <div style="text-align: right">
            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText class="margin0"  size="50" placeholder="Global Filter"
              (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
          </div>
        </ng-template> -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
            </p-sortIcon>
          </th>
        </tr>
        <tr>
          <th *ngFor="let col of columns" [ngSwitch]="col.field">
            <input *ngSwitchCase="'QuestionText'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'questiontype'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td *ngFor="let col of columns">
            <span>{{rowData[col.field]}}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary" let-rowData>
        <div style="text-align:left">
          <button type="button" pButton (click)="showDialogToAdd()" label="Add"></button>
          <button type="button" pButton (click)="openGenerate()" label="Generate with AI" class="left"></button>
        </div>
      </ng-template>
    </p-table>

    <p-dialog header="Question Details" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true"
      [style]="{width: '500px'}">
      <div class="red-text" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="ui-g ui-fluid" *ngIf="question">
        <div class="ui-g-12">
          <div class="ui-g-4">
            <label for="sourceschool">Quiz</label>
          </div>
          <div class="ui-g-8">
            {{ quiz.QuizTitle }}
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4">
            <label for="sourceschool">QuestionText</label>
          </div>
          <div class="ui-g-8">
            <input pInputText class="margin0" id="QuestionText" [(ngModel)]="question.QuestionText" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="QuestionType">QuestionType</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="QuestionType" [(ngModel)]="question.questiontype" required />
          </div>
        </div>

      </div>
      <ng-template pTemplate="footer">
        <div class="ui-dialog-buttonpane ui-helper-clearfix" *ngIf="question">
          <a target="_blank" (click)="gotoAnswerOptions($event)" type="button" pButton label="Answer Options"
            class="left"></a>
          <button type="button" pButton (click)="delete()" label="Delete" class="left"></button>
          <button type="button" pButton (click)="save()" [disabled]="!question.QuestionText || !question.questiontype"
            label="Save"></button>
        </div>

      </ng-template>

    </p-dialog>

    <p-dialog header="Generate Questions with AI" [(visible)]="genDialog" [responsive]="true" showEffect="fade"
      [modal]="true" [style]="{width: '720px'}">
      <div class="red-text" *ngIf="genError">{{ genError }}</div>

      <div class="ui-g ui-fluid">
        <!-- Final quiz: choose a content chapter (or all chapters) -->
        <div class="ui-g-12" *ngIf="isFinalQuiz">
          <div class="ui-g-4">
            <label for="genChapter">Chapter (context)</label>
          </div>
          <div class="ui-g-8">
            <p-dropdown id="genChapter" [options]="chapterOptions" [(ngModel)]="selectedChapterId"
              (onChange)="onChapterChange()" appendTo="body"></p-dropdown>
          </div>
        </div>
        <!-- Section header dropdown: always for normal quizzes; for final quizzes
             only once a specific chapter is chosen -->
        <div class="ui-g-12" *ngIf="!isFinalQuiz || selectedChapterId">
          <div class="ui-g-4">
            <label for="genHeader">Section header (context)</label>
          </div>
          <div class="ui-g-8">
            <div *ngIf="genSectionsLoading" class="white">Loading sections&hellip;</div>
            <p-dropdown *ngIf="!genSectionsLoading && headerOptions.length" id="genHeader"
              [options]="headerOptions" [(ngModel)]="selectedHeaderId" appendTo="body"
              placeholder="Select a section header"></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4">
            <label for="genCount">How many</label>
          </div>
          <div class="ui-g-8">
            <input pInputText class="margin0" id="genCount" type="number" min="1" max="20"
              [(ngModel)]="genCount" />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4">
            <label for="genNotes">Guidance (optional)</label>
          </div>
          <div class="ui-g-8">
            <input pInputText class="margin0" id="genNotes" [(ngModel)]="genNotes"
              placeholder="e.g. focus on seatbelt laws, make them harder" />
          </div>
        </div>
      </div>

      <div *ngIf="genLoading" class="white">Generating&hellip;</div>

      <div *ngIf="suggestions.length" class="gen-suggestions">
        <div *ngFor="let s of suggestions; let i = index" class="gen-suggestion"
          [class.gen-selected]="s.selected" (click)="s.selected = !s.selected">
          <div class="white gen-suggestion-q">
            <span class="gen-check">{{ s.selected ? '☑' : '☐' }}</span>
            <strong>&nbsp;{{ i + 1 }}.&nbsp;{{ s.questionText }}</strong>
          </div>
          <ul>
            <li *ngFor="let o of s.options" [class.gen-correct]="o.correct">
              {{ o.text }}<span *ngIf="o.correct"> &nbsp;(correct)</span>
            </li>
          </ul>
        </div>
      </div>

      <ng-template pTemplate="footer">
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
          <button type="button" pButton (click)="generate()"
            [disabled]="genLoading || !canGenerate()"
            label="Generate"></button>
          <button type="button" pButton *ngIf="suggestions.length" (click)="generateMore()"
            [disabled]="genLoading" label="Generate more" class="left"></button>
          <button type="button" pButton *ngIf="suggestions.length" (click)="publishSelected()"
            [disabled]="genLoading || !hasSelected()" label="Publish selected"></button>
        </div>
      </ng-template>

    </p-dialog>
  </div>
</div>
